import React from 'react';
import './style.scss';
import BattleActionBet from '../bet';
import BattleActionNftInfo from '../nftInfo';
import BattleActionCardsBlock from '../cardsBlock';
import NftIcon from '../../../../../general/nft/icon';
import { FightActionAdaptiveViewProps } from './IProps';

const BattleActionMobile = ({
  self,
  opponent,
  handleMove,
  bet
}: FightActionAdaptiveViewProps) => (
  <>
    <div className='faav-block'>
      <div className='faav-tablet-sub-block'>
        <div className='faav-block-line'>
          <BattleActionCardsBlock position='top' player={opponent} />
        </div>
        <div className='faav-block-line mobile'>
          <BattleActionBet bet={bet} mode='mobile' />
          <div className='faav-block-line'>
            <BattleActionNftInfo data={opponent.data} align='right' />
            <NftIcon
              data={opponent.data}
              className='faav-top-icon mobile'
              background={'green'}
              reversed
            />
          </div>
        </div>
      </div>
      <div className='faav-tablet-sub-block'>
        <div className='faav-block-line'>
          <NftIcon
            data={self.data}
            className='faav-bottom-icon mobile'
            background={'blue'}
          />
          <BattleActionNftInfo data={self.data} align='left' />
        </div>
        <div className='faav-block-line'>
          <BattleActionCardsBlock
            position='bottom'
            player={self}
            onClick={handleMove}
          />
        </div>
      </div>
    </div>
  </>
);

export default BattleActionMobile;
